export const API_URL = "https://axsol-coworking.herokuapp.com"
export const templateId = "template_testAxsolCow"
export const serviceId = "service_i71reka"
export const userId = "user_3SUjBiElIFtkq5eJEhl7g"